export const createRiskReturnSeries = (
  series: Props[],
  typeData: 'cagr' | 'profitability' = 'profitability',
  isPercentage = false,
  timeFrame: keyof ITimeframeStats = 'begin'
): ISeriesOutput[] => {
  if (!series || !series?.length) return [];

  const multiplyFactor = isPercentage ? 100 : 1;

  const chartSeries = series
    .filter(
      (item) =>
        item.stats?.timeframe?.[timeFrame]?.volatility &&
        item.stats?.timeframe?.[timeFrame][typeData]
    )
    .map((item) => {
      const timeframe = item?.stats?.timeframe!;

      try {
        const volatility = timeframe?.[timeFrame].volatility as number;
        const profit = timeframe[timeFrame][typeData] as number;

        return {
          data: [[volatility * multiplyFactor, profit * multiplyFactor]],
          name: item.shortname || item.nicename,
          color: item.color,
          type: 'scatter',
          id: item.id,
          visible: item.visible === undefined ? true : item.visible,
          ...(item.marker ? { marker: item.marker } : {}),
        };
      } catch (error) {
        return null;
      }
    })
    .filter(Boolean) as ISeriesOutput[];

  return chartSeries;
};

type ISeriesOutput = {
  data: number[][];
  name: string;
  color: string;
  type: 'scatter';
  id: string;
  visible: boolean;
  marker: Highcharts.PointMarkerOptionsObject;
} & Highcharts.SeriesOptionsType;

interface Props {
  nicename: string;
  shortname?: string;
  id?: string;
  color?: string;
  stats?: IStats;
  visible?: boolean;
  marker?: Highcharts.PointMarkerOptionsObject;
}

interface IStats {
  timeframe: ITimeframeStats;
}

interface ITimeframeStats {
  last_3_months: IStatsMonth;
  last_6_months: IStatsMonth;
  last_12_months: IStatsMonth;
  last_24_months: IStatsMonth;
  last_36_months: IStatsMonth;
  ytd: IStatsMonth;
  mtd: IStatsMonth;
  begin: IStatsMonth;
}

interface IStatsMonth {
  cagr: number | null;
  profitability: number | null;
  volatility: number | null;
  sharpe_ratio: number | null;
}
